module.exports = __webpack_public_path__ + "static/media/NarwhalLogoWithNameDark.263cc1b3.svg";